// Copyright (c) 2020-2021 Visual Intelligence LP. All rights reserved.
//
export const MAX_VENDORS = 9999;
export enum VendorType {
  collection = 1,
  processing = 2,
  analytics = 3
}

export const VENDOR_TYPES_LABELS = {
  [VendorType.collection]: 'Collection',
  [VendorType.processing]: 'Processing',
  [VendorType.analytics]: 'Analytics',
};

export const VENDOR_FIELDS = {
  id: 'id',
  name: 'name',
  types: 'types',
  accountingCode: 'accountingCode',

  address: {
    name: 'address',
    fields: {
      street: 'addressLine',
      city: 'city',
      state: 'state',
      zipCode: 'zipCode',
      country: 'country'
    }
  },
  businessContact: {
    name: 'businessContact',
    fields: {
      contactName: 'name',
      title: 'title',
      email: 'email',
      phone: 'phone',
    }
  },
  projectManagers: {  // This used to be an array.
    name: 'projectManagers',
    fields: {
      name: 'name',
      title: 'title',
      email: 'email',
      phone: 'phone',
      blocked: 'blocked'
    }
  },
};

export const VENDOR_USER_FIELDS = {
  id: 'id',
  fullName: 'fullName',
};